import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { BackendService } from './services/backend.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';


import {
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatNativeDateModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCardModule,
    MatTooltip
} from '@angular/material';

import { BusySpinnerComponent } from './busy-spinner/busy-spinner.component';
import { CdkTableModule } from '@angular/cdk/table';
import { RecaptchaTokenService } from './services/recaptcha-token.service';
import { GenericErrorDialogComponent } from './dialogs/generic-error-dialog/generic-error-dialog';
import { CleanProductCodePipe } from './pipes/clean-product-code.pipe';
import { RequestSentDialogComponent } from './dialogs/request-sent-dialog/request-sent-dialog';
import { IncorrectCaptchaDialogComponent } from './dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog';
import { ProductNotFoundDialogComponent } from './dialogs/product-not-found-dialog/product-not-found-dialog';
import { InvalidInputDialogComponent } from './dialogs/invalid-input-dialog/invalid-input-dialog';
import { SalesRequestOkDialogComponent } from './dialogs/sales-request-ok-dialog/sales-request-ok-dialog';
import { WrongLanguageDialogComponent } from './dialogs/wrong-language-dialog/wrong-language-dialog';

@NgModule({
    declarations: [
        AppComponent,
        BusySpinnerComponent,
        RequestSentDialogComponent,
        GenericErrorDialogComponent,
        CleanProductCodePipe,
        IncorrectCaptchaDialogComponent,
        ProductNotFoundDialogComponent,
        InvalidInputDialogComponent,
        SalesRequestOkDialogComponent,
        WrongLanguageDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,
        // AngularGooglePlaceModule,
        CdkTableModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatNativeDateModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatTooltipModule,
        RouterModule.forRoot([]),
        RecaptchaModule.forRoot({
            siteKey: '6LcDmkQUAAAAAC6gln7-oYrabL6t6Qm4biYTQq82',
        })
    ],
    entryComponents: [
        RequestSentDialogComponent,
        GenericErrorDialogComponent,
        IncorrectCaptchaDialogComponent,
        ProductNotFoundDialogComponent,
        WrongLanguageDialogComponent,
        InvalidInputDialogComponent,
        SalesRequestOkDialogComponent
    ],
    providers: [
        { provide: LOCALE_ID, useValue: 'it' },
        BackendService,
        RecaptchaTokenService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts